import { render } from "./FormRolComponent.vue?vue&type=template&id=6451ecb3"
import script from "./FormRolComponent.vue?vue&type=script&lang=js"
export * from "./FormRolComponent.vue?vue&type=script&lang=js"

import "./FormRolComponent.vue?vue&type=style&index=0&id=6451ecb3&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__